module.exports = __webpack_public_path__ + "img/29.71e52e1b.jpg";